export module __hack {}

// instruct monaco-editor how we named the
// bundles that contain the web workers.
declare global {
  interface Window {
    MonacoEnvironment: any;
  }

  let __webpack_public_path__: string | undefined;
}

const PUBLIC_PATH = __webpack_public_path__ || './';

self.MonacoEnvironment = {
  getWorkerUrl: function(moduleId: string, label: string) {
    if (label === 'typescript' || label === 'javascript') {
      return `${PUBLIC_PATH}ts.worker.js`;
    }
    if (label === 'greycat') {
      return `${PUBLIC_PATH}gc.worker.js`;
    }
    return `${PUBLIC_PATH}editor.worker.js`;
  },
};
